import colors from "@digits-shared/themes/colors"

export const svgIconStyles = (color: string, transition?: boolean) => `
  fill: ${color};

  g:not([fill="none"]) {
    fill: ${color};
  }

  path {
    transition: ${transition ? "fill 250ms ease" : "none"};
  }

  *[stroke-miterlimit],
  circle,
  ellipse {
    transition: ${transition ? "stroke 250ms ease" : "none"};
    stroke: ${color};
  }

  path[stroke]:not([stroke="none"]) {
    stroke: ${color};
  }

  path[fill]:not([fill="none"]) {
    fill: ${color};
  }

  path[fill="#010101"] {
    fill: ${color};
  }
`

export const svgPathStyles = (
  color: string,
  strokeWidth?: number | string,
  transition?: boolean
) => `
  path,
  rect,
  circle,
  line,
  polyline {
    stroke: ${color};
    transition: ${transition ? "stroke 250ms ease" : "none"};

    ${strokeWidth ? `stroke-width: ${typeof strokeWidth === "number" ? `${strokeWidth}px` : strokeWidth};` : ""}
  }
`

export const svgBrandedPathStyles = (
  fallbackColor = colors.white,
  strokeWidth = 1.5,
  transition?: boolean
) => svgPathStyles(`var(--brand-header-text-color, ${fallbackColor})`, strokeWidth, transition)
